import { withStyles, Grid } from '@material-ui/core';
import Label from '../../Dispatch/RouteExecution/ProDetails/common/Label';
import Detail from '../../Dispatch/RouteExecution/ProDetails/common/Detail';
import { format } from 'date-fns';
import appConstants from '../../../../appConstants';
import { getCombinedIconsArray } from '../../../mapComponents/Popups/PopupUtil';
import { formatMonthDateYear, formatDateTime,getUTCDate } from '@dataGrid/gridUtilities';
import SpecialNeedsRenderer from './SpecialNeedsRenderer';
const styles = (theme) => ({
  container: {
    margin: '16px 0px'
  },
  shipperValue: {
    fontSize: theme.headerTextFontSize,
    marginBottom: 4
  },
  shipperDetailContainer: {
    margin: '16px 0px'
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: 16
  }
});
const ShipmentDetails = ({ classes, proData }) => {
  const combinedIconsArray = getCombinedIconsArray({ shipmentData: proData, specialNeedsOptions: appConstants.SpecialNeeds});
  return (
    <div className={classes.container}>
      <Label labelText="SHIPMENT DETAILS" />
      <Grid container spacing={16} className={classes.shipperDetailContainer}>
        {/* 1st row */}
        <Grid item xs={6} sm={4}>
          <Detail
            label="Spl Needs"
            value={<SpecialNeedsRenderer iconsList={combinedIconsArray} />}
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail label="Status" value={proData.shipmentStatus || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail
            label="Pick-up Date"
            value={proData.pickupDate ? formatMonthDateYear({ value: proData.pickupDate }) : '-'}
          />
        </Grid>

        {/* 2nd row */}
        <Grid item xs={6} sm={4}>
          <Detail label="Org Term" value={proData.originTerminal || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail label="Dest Term" value={proData.destinationTerminal || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail label="Curr Term" value={proData.currentTerminal || '-'} />
        </Grid>

        {/* 3rd row */}
        <Grid item xs={6} sm={4}>
          <Detail label="Curr Trlr" value={proData.currentTrailer || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail label="Curr Mfst" value={proData.currentManifest || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail
            label="APT Due Date"
            value={proData.aptDueDate ? formatMonthDateYear({ value: proData.aptDueDate }) : '-'}
          />
        </Grid>

        {/* 4th row */}
        <Grid item xs={6} sm={4}>
          <Detail
            label="IB ETA"
           value={
              proData.inboundArrivalTime
                ? format(getUTCDate(proData.inboundArrivalTime), 'MM/dd/yy HH:mm')
                : '-'
            }
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail
            label="Act Arr Time"
            value={
              proData.actualArrivalTime
                ? formatDateTime({
                    value: proData.actualArrivalTime
                  })
                : '-'
            }
          />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail
            label="Due Date"
            value={proData.dueDate ? formatMonthDateYear({ value: proData.dueDate }) : '-'}
          />
        </Grid>

        {/* 5th row */}
        <Grid item xs={6} sm={4}>
          <Detail label="Delivery Window" value={proData.deliveryWindow || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail label="Bay Location" value={proData.bayLocation || '-'} />
        </Grid>
        <Grid item xs={6} sm={4}>
          <Detail label="Return Code" value={proData.returnCode || '-'} />
        </Grid>

        {/* 6th row */}
        <Grid item xs={6} sm={4}>
          <Detail label="Return Date" value={proData.returnDate ? formatMonthDateYear({ value: proData.returnDate }) : '-'} />
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(ShipmentDetails);
